import './SafetyCard.less';
import React from 'react';
import { inject, observer } from 'mobx-react';
import HistoryChart from '../HistoryChart/HistoryChart';
import { Card, Recharts, Carousel, AppLocaleProvider } from 'sd-ui-components';

const { FormattedMessage } = AppLocaleProvider;
const { ResponsiveContainer } = Recharts;

@inject('SafetyStore')
@observer
class HistoryChartCard extends React.Component {
  render() {
    const historyItemsCount = this.props.SafetyStore.historyItemsCount;
    // Note: In some cases we won't have an even number of items
    const midwayPoint = Math.floor(historyItemsCount / 2);

    return (
      <div>
        <Card
          loading={this.props.SafetyStore.loading.getSafetyScore}
          className="history-chart-container"
        >
          <h4 className="safety-history-card-title">
            <FormattedMessage
              id="App.Safety.ScoreHistoryTitle"
              defaultMessage="My score history"
            />
          </h4>

          {!this.props.SafetyStore.noHistoryScoresAvailable &&
            !this.props.SafetyStore.loading.getSafetyScore && (
              <Carousel
                dots={true}
                externalNavigation={true}
                infinite={false}
                data-automation-id="sd-ui-driver-safety-carousel"
                ref={carousel => {
                  if (carousel) {
                    carousel.goTo(1);
                  }
                }}
              >
                <HistoryChart startingIndex={0} endingIndex={midwayPoint} />
                <HistoryChart
                  startingIndex={midwayPoint}
                  endingIndex={historyItemsCount}
                />
              </Carousel>
            )}

          {this.props.SafetyStore.noHistoryScoresAvailable &&
            !this.props.SafetyStore.loading.getSafetyScore && (
              <ResponsiveContainer height={236}>
                <div>
                  <h5 className="safety-history-no-data-available">
                    <FormattedMessage
                      id="App.Safety.NotEnoughData"
                      defaultMessage="Not enough data available."
                    />
                  </h5>
                </div>
              </ResponsiveContainer>
            )}
        </Card>
      </div>
    );
  }
}

export default HistoryChartCard;



// WEBPACK FOOTER //
// ./src/containers/Safety/SafetyCards/HistoryChartCard.jsx